export default "__VITE_ASSET__94e6c3ef__"